import styled, { css } from 'styled-components'

export const ContentSection = styled.section`
  align-self: center;
  width: 100%;
  padding: 0 1.25rem;

  ${({ theme }) => theme.screenWidth}
`

export const Content = styled.div`
  display: flex;
  flex: 0 1;
  flex-direction: column;
  position: relative;
  width: 100%;

  &.result-list {
    min-height: calc(100vh - 306px);
  }
  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          flex: 0;
        `

      default:
        return {}
    }
  }}
`
